<template>
  <div>
    <v-menu v-model="shouldShowDialog" :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <span
          class="d-inline-flex align-center filter-title"
          :class="{ 'font-weight-bold': isFilterApplied }"
          v-on="on"
          v-bind="attrs"
        >
          <v-icon left>
            favorite
          </v-icon>
          Likes
          <v-icon>
            expand_more
          </v-icon>
        </span>
      </template>
      <v-card>
        <v-card-text class="black--text">
          <div>
            <v-icon class="mr-1 black--text">favorite_border</v-icon>
            Post Likes
          </div>

          <v-row class="mt-3">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.from"
                type="number"
                label="From"
                dense
                outlined
                @keyup="submitForm"
                @keyup.enter="shouldShowDialog = false"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.to"
                type="number"
                label="To"
                dense
                outlined
                @keyup="submitForm"
                @keyup.enter="shouldShowDialog = false"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { minValue } from 'vuelidate/lib/validators'

const originalForm = () => ({
  from: "",
  to: ""
})

export default {
  name: "FilterLikes",

  props: {
    moduleId: {
      type: [Symbol, String, Number],
      required: true
    }
  },

  data: () => ({
    shouldShowDialog: false,

    form: originalForm()
  }),

  computed: {
    // use the inputs to generate some text value
    textValue() {
      let computedText = ''

      // when both values are present
      if (this.form.from && this.form.to) computedText = `${parseInt(this.form.from, 10).toLocaleString()} - ${parseInt(this.form.to, 10).toLocaleString()}`

      // when only left is present
      if (this.form.from && !this.form.to) computedText = `> ${parseInt(this.form.from, 10).toLocaleString()}`

      // when only right is present
      if (!this.form.from && this.form.to) computedText = `< ${parseInt(this.form.to, 10).toLocaleString()}`

      return `Likes: ${computedText}`
    },

    isFilterApplied() {
      return Boolean(this.$store.getters["paidCollaborations/findFilterByType"](this.moduleId, "likes"))
    }
  },

  validations: {
    form: {
      from: {
        minValue: minValue(0)
      },
      to: {
        minValue: minValue(0)
      }
    }
  },

  methods: {
    async submitForm() {
      await this.$v.$touch()

      if (this.$v.$anyError) return

      this.$store.dispatch("paidCollaborations/replaceFilter", {
        id: this.moduleId,
        type: "likes",
        data: {
          color: "pink lighten-5",
          icon: "favorite",
          iconColor: "pink",
          text: this.textValue,
          inputs: {
            ...this.form
          }
        }
      })
    }
  },

  mounted() {
    // set default value for it
    this.form.from = 1000
    this.submitForm()

    // subscribe to window event when the chip is closed
    window.addEventListener("removeFilter", (e) => {
      // if it's not the one we want, don't execute the code
      if (e.detail.module !== "paidCollaborations" || e.detail.item.type !== "likes") return

      // for cases of paid collaborations, make sure to only remove the correct one
      if (this.moduleId !== e.detail.moduleId) return

      // now that it is the one we want to see, continue
      this.form = originalForm()
    })

    // subscribe to window event when the chip is closed
    window.addEventListener("addFilter", (e) => {
      // if it's not the one we want, don't execute the code
      if (e.detail.module !== "paidCollaborations" || e.detail.item.type !== "likes") return

      // for cases of paid collaborations, make sure to only remove the correct one
      if (this.moduleId !== e.detail.moduleId) return

      // now that it is the one we want to see, continue
      this.form = { ...e.detail.item.data.inputs }
    })
  }
}
</script>
